import Script from 'next/script';

export default function GoogleAnalytics(): JSX.Element {
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-0QXKQC7HNM"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-0QXKQC7HNM');`}
      </Script>
    </>
  );
}
